import gql from 'graphql-tag';

export const UPDATE_ESTATE_COST_CALCULATION_MUTATION = gql`
  mutation updateEstateCostCalculation(
    $estateCostCalculationInputDetails: EstateCostCalculationInput!
  ) {
    updateEstateCostCalculation(
      estateCostCalculationInput: $estateCostCalculationInputDetails
    ) {
      id
      testatorId
      totalPropertyValue
      nonPropertyAssetValue
      deemedAssetsValue
      allAssetsLeftToSpouse
      assetValueLeftToSpouse
      hasEstateDutyRollover
      estateDutyRolloverAmount
      otherLiabilities
      totalLiabilities
      executorFeePercentage
      grossEstateValue
      conveyancingFees
      executorFees
      standardAdministrativeCosts
      mastersFees
      estateDuty
      dutiableEstateBefore4aDeduction
      propertyOwnershipValue
      estimatedEstateAdministrativeCosts
      lastCalculationTime
      testamentaryTrustFees
      estateAdministrationServicesCost
      recommendedEstateCoverAmount
      coverLimitReached
      estateDutyExceeded
      capitalGainsTaxAmount
    }
  }
`;
